export const customers = {
  title: 'Customers',
  name: 'Customer',
  resourceName: 'Customers',
  titles: {
    detail: 'Customer details',
    view: 'Customer details',
    show: 'View customer',
    edit: 'Edit customer',
    create: 'Create customer',
    list: 'Customer list',
    addQuick: 'Add quick',
  },
  messages: {
    noData: 'No data',
    totalCustomers: 'Total: {total} customers',
    savedSuccess: 'Saved successfully',
    saving: 'Saving...',
    updateSuccess: 'Customer updated successfully',
    createSuccess: 'Customer created successfully',
    errorGeneric: 'An error occurred',
    loadDetailError: 'Could not load customer details',
  },
  validation: {
    codeNameRequired: 'Please enter customer code and name',
    codeRequired: 'Please enter customer code',
    nameRequired: 'Please enter customer name',
    emailInvalid: 'Invalid email',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
  },
  gender: {
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  fields: {
    companyName: 'Company',
    phoneNumber: 'Phone number',
    id: 'ID',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    area: 'Area',
    status: 'Status',
    isActive: 'Status',
    createdAt: 'Created at',
    actions: 'Actions',
    fromWarehouse: 'From warehouse',
    toWarehouse: 'To warehouse',
    toWarehouseCode: 'To warehouse code',
    container: 'Container',
    totalVolume: 'Total volume',
    totalWeight: 'Total weight',
    subCode: 'Sub code',
    salesName: 'Sales',
    pricePerKg: 'Price per kg',
    pricePerM3: 'Price per m3',
    priceEachRow: 'Price each row',
    entrustmentPercent: 'UTNK / Get tax',
    code: 'Code',
    getTax: 'Get tax',
    codeLabel: 'Customer code',
    nameLabel: 'Customer name',
    updatedAt: 'Updated at',
    notes: 'Notes',
  },
  tabs: {
    mapping: 'Sub-code (Mapping)',
  },
  searchByCode: {
    label: 'Show unlinked only',
    placeholder: 'Search by code or name',
  },
  filter: {
    placeholder: 'Search customers',
    advancedFilter: 'Advanced filter',
    code: 'Customer code',
    name: 'Customer name',
    sales: 'Sales',
    allSales: 'All Sales',
    clearFilter: 'Clear filter',
    search: 'Search',
  },
  customerNotFound: 'Customer not found',
  attachMainCode: 'Attach main code',
  import: {
    button: 'Import',
    title: 'Import customers',
    description: 'Select an XLSX file (formatted according to the template).',
    noSheet: 'No sheet found in the Excel file',
    readError: 'Failed to read Excel file',
    noData: 'No data to import',
    success: 'Successfully imported {count} customers',
    failed: 'Import failed',
    savedSuccess: 'Saved successfully',
    templateSheetName: 'Customer import template',
    templateFileName: 'Customer_import_template.xlsx',
    templateSuccess: 'Template file downloaded successfully',
    templateFailed: 'Failed to download template file',
    templateLoading: 'Downloading...',
    templateButton: 'Download template',
  },
  export: {
    button: 'Export',
    loading: 'Exporting...',
    success: 'Excel file exported successfully',
    failed: 'Export failed',
    fileName: 'Customer_list.xlsx',
    fileNameMapping: 'mapping_list.xlsx',
    sheetName: 'Customer list',
    mappingSheetName: 'Customer mappings',
  },
  mapping: {
    editTitle: 'Edit mapping',
    importSuccess: 'Mapping import successful',
    importLoading: 'Importing...',
    importTitle: 'Import mapping',
    importDescription: 'Select an XLSX file (formatted according to the template).',
    templateSheetName: 'Mapping import template',
    templateFileName: 'Mapping_import_template.xlsx',
    templateSubCode: 'Sub code',
    templateCustomerCode: 'Customer code',
    templateWarehouseCode: 'Warehouse code',
    templatePriceEachRow: 'Price/row',
    templatePricePerKg: 'Price/kg',
    templatePricePerM3: 'Price/m³',
    templateIsGetTax: 'Get tax',
    templateEntrustmentPercent: 'Entrustment %',
  },
  form: {
    basicInfo: 'Basic information',
    contactInfo: 'Contact information',
    managerInfo: 'Manager information',
    servicePriceInfo: 'Service & pricing',
    otherInfo: 'Other information',
    isActiveLabel: 'Active',
    noSelect: 'None',
    getTaxLabel: 'Get invoice',
    createdByPlaceholder: 'Created by',
    introduceByPlaceholder: 'Introduced by',
    inChargeByPlaceholder: 'Person in charge',
    areaPlaceholder: 'Area',
    entrustmentPlaceholder: 'Entrustment percent',
    priceEachRowPlaceholder: 'Price per row',
    pricePerKgPlaceholder: 'Price per kg',
    pricePerM3Placeholder: 'Price per m³',
    genderLabel: 'Gender',
  },
}
